import enterView from "enter-view";

// Hooks
//
const itemHook = "[js-sticky-item]";
const startHook = "[js-sticky-item-start]";
const endHook = "[js-sticky-item-end]";
const innerHook = "[js-sticky-item-inner]";
const visualHook = "[js-sticky-visual]";
const imageHook = "[js-sticky-image]";

// Classes
//
const activeClass = "sticky-image__item--active";

class Sticky {
  constructor(element) {
    this.element = element;
    this.items = element.querySelectorAll(itemHook);
    this.start = element.querySelector(startHook);
    this.end = element.querySelector(endHook);
    this.inner = element.querySelector(innerHook);
    this.visual = element.querySelector(visualHook);
    this.images = element.querySelectorAll(imageHook);
    this.currentId = 1;
    this.progress = []

    this.init();
  }

  init() {
    this.items.forEach(ele => {
      this.progress.push({ id: ele.dataset.id, progress: 0 })
    })

    this.images.forEach(ele => {
      if (ele.dataset.id == this.currentId) {
        ele.classList.add('active')
      }
    })

    this.detect();
    this.detectStart();
    this.detectEnd();
  }

  detect() {
    const changeProgress = (element, progress) => {
      const index = this.progress.findIndex((obj => obj.id == element.dataset.id));
      this.progress[index].progress = progress

      if (progress == 0) {
        handleExit(element)
      } else if ((progress > 0) && (progress < 1)) {
        handleEnter(element)
      } else {
        handleExit(element)
      }
    }

    const handleEnter = (element) => {
      element.classList.add(activeClass);

      this.images.forEach(e => {
          e.classList[e.dataset.id == element.dataset.id ? 'add' : 'remove']('active')
      })
    }

    const handleExit = (element) => {
      element.classList.remove(activeClass)
    }

    enterView({
      selector: itemHook,
      offset: 0.5,
      enter: function (el) {
        handleEnter(el)
      },
      exit: function(el) {
        handleExit(el)
      },
      progress: function(el, progress) {
        changeProgress(el, progress)
      },
      once: false
    });
  }

  detectStart() {
    const progressHandler = (progress) => {
      this.visual.classList[progress == 1 ? 'add' : 'remove']('sticky-image__visual--active')
      this.visual.classList.add('sticky-image__visual--start')
    }

    enterView({
      selector: startHook,
      offset: 0,
      progress: function(el, progress) {
        progressHandler(progress)
      },
      once: false
    });
  }

  detectEnd() {
    const progressHandler = (progress) => {
      this.visual.classList[progress == 1 ? 'add' : 'remove']('sticky-image__visual--done')
    }

    enterView({
      selector: endHook,
      offset: 0,
      progress: function(el, progress) {
        progressHandler(progress)
      },
      once: false
    });
  }
}

export default Sticky;
